import { render, staticRenderFns } from "./ConfirmRemove.vue?vue&type=template&id=42845aa7&scoped=true&"
import script from "./ConfirmRemove.vue?vue&type=script&lang=js&"
export * from "./ConfirmRemove.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmRemove.vue?vue&type=style&index=0&id=42845aa7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42845aa7",
  null
  
)

export default component.exports